import * as Constants from "../../config/constants/Constants.js";
import { createUrl, catchAPIResponse, catchAPIError } from "./http.js";
import { sessionExpired } from "./authQueries.js";

/** Turn API-relative image paths into absolute URLs for <img src>. */
export const mediaUrl = (path) => {
    if (!path) return "/images/image_placeholder.png";
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith("/images/")) return path;
    return createUrl({ path });
};

export const importSheetsExportZip = async (props, file) => {
    const url = createUrl({ path: Constants.API_IMAGES_IMPORT_EXPORT });
    const body = new FormData();
    body.append("file", file);

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: props.user.userJWT ? `Bearer ${props.user.userJWT}` : ""
            },
            body
        });
        const contentType = response.headers.get("Content-Type") || "";
        const data = contentType.includes("application/json") ? await response.json() : undefined;
        const result = { ok: response.ok, body: data, status: response.status };
        if (!response.ok) {
            catchAPIResponse(props, result, {
                onUnauthorized: () => sessionExpired(props)
            });
            return null;
        }
        return data;
    } catch (err) {
        catchAPIError(props, err);
        return null;
    }
};

export const importSheetsExportFolder = async (props) => {
    const url = createUrl({ path: Constants.API_IMAGES_IMPORT_FOLDER });
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: props.user.userJWT ? `Bearer ${props.user.userJWT}` : ""
            }
        });
        const contentType = response.headers.get("Content-Type") || "";
        const data = contentType.includes("application/json") ? await response.json() : undefined;
        const result = { ok: response.ok, body: data, status: response.status };
        if (!response.ok) {
            catchAPIResponse(props, result, {
                onUnauthorized: () => sessionExpired(props)
            });
            return null;
        }
        return data;
    } catch (err) {
        catchAPIError(props, err);
        return null;
    }
};
